const toggleArrayItem = (existingArray, item, filter = true) => {
  let newArray = [];

  if (existingArray.includes(item) && filter) {
    newArray = [...existingArray, item].filter((param) => param !== item);
  } else if (!existingArray.includes(item)) {
    newArray = [...existingArray, item];
  } else {
    newArray = [...existingArray];
  }

  return newArray;
};

export default toggleArrayItem;
